/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Link } from "../../Link";
import { Img } from "../../Images/Image/Img";
import * as styles from "./CardImage.module.scss";

const CardImage = props =>
	props.clickable ? (
		<Link to={props.clickable?.to}>
			<Img {...props} wrapperClassName={cx(styles.image, props.className)} />
		</Link>
	) : (
		<Img {...props} wrapperClassName={cx(styles.image, props.className)} />
	);

CardImage.displayName = "CardImage";

CardImage.propTypes = {
	fluid: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	source: PropTypes.shape({
		src: PropTypes.string,
		srcSet: PropTypes.string,
		sizes: PropTypes.string,
	}),
	alt: PropTypes.string.isRequired,
	src: PropTypes.string,
	clickable: PropTypes.shape({
		to: PropTypes.string,
	}),
	className: PropTypes.string,
};

CardImage.defaultProps = {
	fluid: undefined,
	source: undefined,
	src: undefined,
	clickable: undefined,
	className: "",
};

export default CardImage;
export { CardImage };
